import { render, staticRenderFns } from "./DepositSendBtn.vue?vue&type=template&id=130fc50a"
import script from "./DepositSendBtn.vue?vue&type=script&lang=js"
export * from "./DepositSendBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports